import { StylesConfig } from 'react-select';
import styled from 'styled-components';

import { colors } from '../../../styles/constants';

export const reactSelectStyleOverrides: StylesConfig = {
  container: (base) => ({
    ...base,
    fontFamily: 'Roboto, sans-serif',
    fontWeight: '300',
    fontSize: '18px',
    borderRadius: '8px',
    width: '100%',
  }),
  control: (base) => ({
    ...base,
    borderRadius: '8px',
    boxShadow: 'none',
    paddingInline: '8px',
    borderColor: '#cccccc', // TODO: Add ability to customize focus outline in SB
    ':hover': {
      borderColor: '#cccccc',
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '8px',
    marginTop: '4px',
  }),
  indicatorSeparator: (base) => ({ ...base, display: 'none' }),
  dropdownIndicator: (base, props) => ({
    ...base,
    transition: 'transform 0.2s ease',
    transform: props.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    color: '#333',
    backgroundColor: isSelected || isFocused ? colors.lightGray : undefined,
    height: '44px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
  }),
};

export const FormBuilderSelectWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  .form-select-custom__control {
    font-size: 16px;
    padding-inline: 2px;
  }

  ${({ theme }) => theme.mediaQuery.sm} {
    .form-select-custom__control {
      height: 56px;
      font-size: 18px;
      padding-inline: 8px;
    }
  }
`;

export const FormBuilderSelectErrorMessage = styled.div`
  margin-top: 6px;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  color: ${colors.red};
`;
